export default __webpack_public_path__ + "static/media/placa.38d4055b.png";